import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '../../core/services/auth/auth.service';
import { MessagingService } from '../../core/services/messaging/messaging.service';
import { NotificationService } from '../../core/services/notification/notification.service';
import { Router } from '@angular/router';
import { SideMenuService } from '../../core/services/side-menu/side-menu.service';
import { ToastService } from '../../core/services/toast/toast.service';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { NotificationApp } from '../../core/models/notification.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {

  @Input() title: string = '';

  notificationPermission: NotificationPermission = 'granted';

  constructor(
    public authService: AuthService,
    private messagingService: MessagingService,
    public notificationService: NotificationService,
    public router: Router,
    public sideMenuService: SideMenuService,
    private toastService: ToastService
  ) { }

  ngOnInit() {
    if ('Notification' in window) {
      this.notificationPermission = Notification.permission;
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                        ANCHOR enableNotifications                          */
  /* -------------------------------------------------------------------------- */
  // region enableNotifications
  async enableNotifications() {

    if (this.notificationPermission === 'denied') {
      this.toastService.show({
        header: 'Notificaciones bloqueadas',
        body: 'Actívalas desde el candado 🔒 de la barra de direcciones del navegador.',
        classname: 'bg-warning text-dark'
      });
      return;
    }

    const result = await this.messagingService.requestPermissionAndRegister();
    this.notificationPermission = result;

    if (result === 'granted') {
      this.toastService.show({
        header: '🔔 Notificaciones activadas',
        body: 'Recibirás alertas cuando un residente te envíe un mensaje.',
        classname: 'bg-success text-white'
      });
    }

  }

  /* -------------------------------------------------------------------------- */
  /*                          ANCHOR getRelativeTime                           */
  /* -------------------------------------------------------------------------- */
  // region getRelativeTime
  getRelativeTime(dateStr: string): string {
    const now = new Date();
    const date = new Date(dateStr);
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    if (diffMins < 1) return 'Ahora';
    if (diffMins < 60) return `${diffMins}m`;
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours}h`;
    const diffDays = Math.floor(diffHours / 24);
    if (diffDays < 7) return `${diffDays}d`;
    return new Date(dateStr).toLocaleDateString('es-MX', { day: 'numeric', month: 'short' });
  }

  /* -------------------------------------------------------------------------- */
  /*                         ANCHOR onNotificationTap                          */
  /* -------------------------------------------------------------------------- */
  // region onNotificationTap
  async onNotificationTap(notification: NotificationApp, dropdown: NgbDropdown) {
    if (!this.notificationService.canTapNotification(notification)) return;
    if (!notification.seen) {
      await this.notificationService.markSeen(notification.notificationId);
    }
    dropdown.close();
    if (
      notification.notificationType?.code === 'chat' &&
      notification.fromHouseFlatId
    ) {
      this.router.navigate(['/app/chat', notification.fromHouseFlatId]);
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                       ANCHOR viewAllNotifications                         */
  /* -------------------------------------------------------------------------- */
  // region viewAllNotifications
  viewAllNotifications(dropdown: NgbDropdown) {
    dropdown.close();
    this.router.navigate(['/app/notifications']);
  }

}
